<template>
  <!--  <p class="font-medium mb-3">Select quantity:</p>-->

  <!--  <select-->
  <!--    class="border border-gray-500 rounded-md px-3 py-2 bg-blue-50"-->
  <!--    v-model="selected"-->
  <!--  >-->
  <!--    <option-->
  <!--      v-for="option in options"-->
  <!--      v-bind:value="option.value"-->
  <!--      :key="`q-${option.value}`"-->
  <!--    >-->
  <!--      {{ option.text }}-->
  <!--    </option>-->
  <!--  </select>-->
  <div>
    <h3 class="text-red-600 uppercase font-medium">Select quantity</h3>
    <p class="text-sm text-gray-700">How Many Do You Want?</p>
    <div class="py-6 border border-gray-300 my-6 rounded">
      <div
        class="px-6 flex text-sm font-medium justify-between border-b border-gray-300 pb-2"
      >
        <p>Item</p>
        <p>Price</p>
      </div>
      <div
        class="px-3 sm:px-6 py-3 flex items-center my-3 cursor-pointer relative text-xs sm:text-base"
        @click="selected = 1"
      >
        <div
          class="w-4 h-4 rounded-2xl mr-3 absolute"
          :class="{
            'border-red-500 border-4': selected === 1,
            'border-gray-300 border': selected !== 1,
          }"
        ></div>
        <p class="w-full pl-10">1 PROFESSIONAL BUG DETECTOR</p>
        <p>$1397</p>
      </div>
      <div
        class="px-3 sm:px-6 py-3 flex items-center my-3 cursor-pointer relative text-xs sm:text-base"
        @click="selected = 2"
      >
        <div
          class="w-4 h-4 rounded-2xl mr-3 absolute"
          :class="{
            'border-red-500 border-4': selected === 2,
            'border-gray-300 border': selected !== 2,
          }"
        ></div>
        <p class="w-full pl-10">2 PROFESSIONAL BUG DETECTOR</p>
        <p class="min-w-max text-right">$2694 <br class="sm:hidden block">(1347$ PER 1)</p>
      </div>
      <div
        class="px-3 sm:px-6 py-3 flex items-center mt-3 cursor-pointer relative bg-yellow-100 border-b border-t border-gray-400 text-xs sm:text-base"
        @click="selected = 3"
      >
        <div
          class="w-4 h-4 rounded-2xl mr-3 absolute"
          :class="{
            'border-red-500 border-4': selected === 3,
            'border-gray-300 border': selected !== 3,
          }"
        ></div>
        <div class="w-full pl-10">
          <p class="text-red-600 font-medium">
            BEST DEAL - protect personal privacy
          </p>
          <p>3 PROFESSIONAL BUG DETECTOR</p>
        </div>
        <p class="min-w-max text-right">$3997 <br class="sm:hidden block">( 1332$ PER 1)</p>
      </div>
    </div>
  </div>

  <div class="mt-8 border-t-2 border-blue-500 py-2 border-b text-xs sm:text-base">
    <span class="font-medium ml-2">ITEM</span>
    <div class="flex mt-2 border-t-2 border-blue-500">
      <div class="font-medium">
        <p class="py-2 px-3 bg-blue-200">
          {{ selected }} PROFESSIONAL BUG DETECTOR AND LOCATOR TODAY
        </p>
        <p class="ml-2 pt-2">Shipping</p>
      </div>
      <div class="flex-auto font-medium">
        <p class="py-2 px-3 bg-blue-200 pl-8 text-center sm:text-left">
          {{ price }} $
        </p>
        <p class="pl-8 pt-2 text-center sm:text-left">140 $</p>
      </div>
    </div>
  </div>
  <div class="grid justify-center mt-8 mb-2">
    <p class="justify-self-center text-red-600 font-medium text-xl">Express credit card checkout</p>
    <p class="justify-self-center text-red-600 font-medium text-xl">No need to have Paypal account</p>
    <img src="@/assets/images/pp.png" alt="Paypal" width="250" class="justify-self-center mt-3 mb-6">
    <button
      class="text-center transition duration-500 ease-in-out bg-red-600 hover:bg-blue-500 transform hover:-translate-y-1 hover:scale-110 rounded-md text-white tracking-wide text-3xl font-medium py-5 w-full px-0 sm:px-20 sm:w-auto"
      @click="openModal()"
    >
      I want to buy!
    </button>
  </div>
  <div
    v-if="modal"
    class="absolute top-0 left-0 w-full flex justify-center overflow-y-auto"
  >
    <div
      class="w-full lg:max-w-4xl m-auto font-roboto my-0 lg:my-6 bg-white z-30 lg:rounded-md px-8"
    >
      <div class="flex items-center">
        <img src="@/assets/images/lock.jpg" width="150" alt="Lock" />
        <div>
          <h4 class="font-medium text-red-800 text-xl mb-2">
            Secure Processing
          </h4>
          <p>
            Each order is processing through secure, 256-bit encripted payment
            processing gateway to ensure your privacy.
          </p>
        </div>
      </div>
      <div class="flex items-center mb-4">
        <img src="@/assets/images/mark.jpg" width="150" alt="Mark" />
        <div>
          <h4 class="font-medium text-red-800 text-xl mb-2">
            Your Unconditional Money-Back Guarantee
          </h4>
          <p>
            If you implement EVERYTHING I show you, and don't see a change in
            your business, I'll refund your money. That's how confident I am!
          </p>
        </div>
      </div>
      <div
        class="bg-gray-100 w-full grid justify-center pt-10 pb-8 rounded-t-md"
      >
        <h3 class="text-center text-red-600 text-3xl font-medium mb-6">
          WAIT! Grab This One Time Offer Today
        </h3>
        <div class="flex gap-3 text-3xl font-bold text-white justify-center">
          <div class="bg-red-700 rounded-md p-3 timer__days hidden">00</div>
          <div class="bg-red-700 rounded-md p-3 timer__hours">00</div>
          <div class="bg-red-700 rounded-md p-3 timer__minutes">00</div>
          <div class="bg-red-700 rounded-md p-3 timer__seconds">00</div>
        </div>
      </div>
      <div
        class="bg-gradient-to-r from-pink-600 to-red-500 p-6 text-white rounded-b-md"
      >
        <p class="text-center text-xl font-medium my-3">
          Buy 1 year subscription FOR 100$ ONLY and Ge 25% OFF FOR
        </p>
        <p class="text-center text-xl font-medium my-3">
          NEXT ORDER + 6 BATTERIES AND Charger FREE!
        </p>
      </div>
      <div class="grid my-6" v-if="buttons">
        <button
          class="transition duration-500 ease-in-out bg-blue-500 hover:bg-red-600 transform rounded-md text-white tracking-wide text-2xl font-medium py-5 w-full px-0 sm:px-20 sm:w-auto px-6"
          @click="payment('add')"
        >
          NEXT ORDER + 6 BATTERIES AND Charger FREE!
        </button>
        <button
          class="my-6 p-6 text-gray-600 hover:text-red-600"
          @click="payment('no')"
        >
          No, I will pass this time
        </button>
      </div>
      <div
        id="paypal-button-container"
        v-if="!buttons"
        class="py-5 flex justify-center"
      ></div>
    </div>
    <div
      class="bg-gray-700 fixed top-0 left-0 w-full h-screen opacity-80 z-10"
      @click="modal = false"
    ></div>
  </div>
</template>

<script>
import { loadScript } from "@paypal/paypal-js";

export default {
  name: "OrderPopup",
  data() {
    return {
      modal: false,
      selected: 3,
      options: [
        { value: 1, text: "1 PROFESSIONAL BUG DETECTOR" },
        { value: 2, text: "2 PROFESSIONAL BUG DETECTOR" },
        { value: 3, text: "3 PROFESSIONAL BUG DETECTOR" },
      ],
      bugs: [
        { id: 1, price: 1397 },
        { id: 2, price: 2694 },
        { id: 3, price: 3997 },
      ],
      buttons: true,
      amount: 0,
      timerId: null,
    };
  },
  computed: {
    price() {
      return this.bugs.find((item) => item.id === this.selected).price;
    },
  },
  methods: {
    openModal() {
      this.buttons = true;
      this.modal = true;
      window.scrollTo(0, 0);
      const deadline = (function (y, m, d) {
        return new Date(y, m - 1, d);
      })(2022, 12, 25);

      setTimeout(() => {
        function countdownTimer() {
          const diff = deadline - new Date();
          if (diff <= 0) {
            clearInterval(this.timerId);
          }
          const $days = document.querySelector(".timer__days");
          const $hours = document.querySelector(".timer__hours");
          const $minutes = document.querySelector(".timer__minutes");
          const $seconds = document.querySelector(".timer__seconds");
          const days = diff > 0 ? Math.floor(diff / 1000 / 60 / 60 / 24) : 0;
          const hours = diff > 0 ? Math.floor(diff / 1000 / 60 / 60) % 24 : 0;
          const minutes = diff > 0 ? Math.floor(diff / 1000 / 60) % 60 : 0;
          const seconds = diff > 0 ? Math.floor(diff / 1000) % 60 : 0;
          $days.textContent = days < 10 ? "0" + days : days;
          $hours.textContent = hours < 10 ? "0" + hours : hours;
          $minutes.textContent = minutes < 10 ? "0" + minutes : minutes;
          $seconds.textContent = seconds < 10 ? "0" + seconds : seconds;
        }
        countdownTimer();
        this.timerId = setInterval(countdownTimer, 1000);
      }, 500);
    },
    async payment(add) {
      this.buttons = false;
      const item = this.options.find(
        (item) => item.value === this.selected
      ).text;
      let a = add === "add" ? 100 : 0;
      let amount =
        this.bugs.find((item) => item.id === this.selected).price + a + 140;
      this.amount = amount;
      let paypal;

      try {
        paypal = await loadScript({
          "client-id":
            "AZEEwbbKeOCOauoWJ3acK_5M45vCGgzySduXf16LBhFo5IPVFQ5eZsYczLanobMXTTjB7t-SZ3NkpCMo",
        });
      } catch (error) {
        console.error("failed to load the PayPal JS SDK script", error);
      }

      if (paypal) {
        try {
          await paypal
            .Buttons({
              createOrder: function (data, actions) {
                // Set up the transaction
                return actions.order.create({
                  purchase_units: [
                    {
                      amount: {
                        value: amount,
                      },
                    },
                  ],
                });
              },
              onApprove: function (data, actions) {
                return actions.order.capture().then(function (details) {
                  const out = details.purchase_units[0];
                  localStorage.setItem("value", out.amount.value);
                  localStorage.setItem("currency", out.amount.currency_code);
                  localStorage.setItem("email", out.payee.email_address);
                  localStorage.setItem("name", out.shipping.name.full_name);
                  localStorage.setItem("add", add);
                  localStorage.setItem("item", item);

                  let adr = Object.keys(out.shipping.address);
                  let address = "";
                  for (let key of adr) {
                    let interval = address === "" ? "" : ", ";
                    address = address + interval + out.shipping.address[key];
                  }
                  localStorage.setItem("address", address);
                  window.location.pathname = "success.html";
                });
              },
            })
            .render("#paypal-button-container");
        } catch (error) {
          console.error("failed to render the PayPal Buttons", error);
        }
      }
    },
  },
};
</script>

<style scoped></style>
